// extracted by mini-css-extract-plugin
module.exports = {"main":"label-field_main__3CgvV","label":"label-field_label__370sU","text":"label-field_text__1XYu4"};